//libs\featureds\public\clients\src\lib\clients.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { clientsRoutes } from './lib.routes';
import { ClientAuthUiModule } from './client-auth-ui.module';

@NgModule({
  imports: [CommonModule,RouterModule.forChild(clientsRoutes), ClientAuthUiModule],
  exports: [ClientAuthUiModule],
})
export class ClientsModule {}
